<template>
  <div class="d-flex justify-content-end align-items-center">
    <el-button
        @click="isImport = true"
        type="primary"
        style="background: #472F92; border: none; color: white"
        class="btn btn-xs"
    >
      <i class="el-icon-star-off"></i> Import điểm trừ
    </el-button>
    <el-dialog
        class="responsive" width="40%"
        v-if="isImport" :visible.sync="isImport" :show-close="false"
        append-to-body :title="title" @close="closeDialog"
    >
      <hr style="margin-top: -20px; border: 1px solid lightgray; margin-bottom: 20px"/>
      <DialogImportMinusPoint
          @closeDialog="closeDialog"
          @getListMinusPoint="getListMinusPoint"
          @setTitleError="setTitleDialogError"
      />
    </el-dialog>
  </div>
</template>

<script>
import DialogImportMinusPoint from "@/view/pages/manage-minus-point/component/DialogImportMinusPoint.vue";

export default {
  name: 'HeaderManageMinusPoint',
  components: { DialogImportMinusPoint },
  data() {
    return {
      isCreate: false,
      isImport: false,
      title: "Import điểm trừ",
    }
  },
  methods: {
    getListMinusPoint() {
      this.$emit('getListMinusPoint')
    },
    setTitleDialogError(value) {
      this.title = value
    },
    closeDialog() {
      this.listErrors = []
      this.fileImport = null
      this.tableError = false
      this.disableImport = false
      this.isImport = false
      this.title = "Import điểm trừ"
    },
  }
}
</script>

<style scoped>

</style>